import { TouchKeyboardLogin } from "./login-modal/components/TouchKeyboardLogin";
import { CraneSelectionModal } from "./login-modal/components/CraneSelectionModal";
import { BilletYardOperator } from "../../models/authModels";

interface LoginModalProps {
  // Authentication state
  isLoggedIn: boolean;
  shouldBypassCraneSelection: boolean;

  // Session data
  selectedCraneId: number | null;
  selectedOperatorId: number | null;

  // Permissions and capabilities
  isTouchMode: boolean;

  // Event handlers
  onOpenCraneSelection: () => void;
  onTouchLoginSuccess: (operatorCode: string) => void;
  onTouchKeypadClose: () => void;
  onCraneSelect: (craneId: number | null) => void;
  onOperatorSelect: (operator: BilletYardOperator | null) => void;

  // Modal state
  showTouchKeypad: boolean;
  showCraneSelection: boolean;
  onCloseCraneSelection: () => void;
}

export const LoginModal = ({
  isLoggedIn,
  shouldBypassCraneSelection,
  selectedCraneId,
  selectedOperatorId,
  isTouchMode,
  onOpenCraneSelection,
  onTouchLoginSuccess,
  onTouchKeypadClose,
  onCraneSelect,
  onOperatorSelect,
  showTouchKeypad,
  showCraneSelection,
  onCloseCraneSelection,
}: LoginModalProps) => {
  return (
    <>
      {/* Always render the modals regardless of login state */}
      <TouchKeyboardLogin
        open={showTouchKeypad}
        onLoginSuccess={onTouchLoginSuccess}
        onClose={onTouchKeypadClose}
      />

      <CraneSelectionModal
        open={showCraneSelection}
        onClose={onCloseCraneSelection}
        selectedCraneId={selectedCraneId}
        selectedOperatorId={selectedOperatorId}
        onCraneSelect={onCraneSelect}
        onOperatorSelect={onOperatorSelect}
      />
    </>
  );
};
